import OnboardingProgress from './OnboardingProgress';

export default OnboardingProgress;
